import React, {useContext, useEffect, useRef, useState} from 'react';
import { Context } from "../../index";
import {Row, Col, Table} from "react-bootstrap";
import {observer} from "mobx-react-lite";
import AssignLibraryItem3x from "./AssignLibraryItem3x";
import {editAssignment, markAssignmentLibraryView} from "../../http/bookAPI";
import AssignLibraryItem4x from "./AssignLibraryItem4x";
import TakeThisAssignment from "../modals/assign/TakeThisAssignment";
import {toast} from "react-toastify";
import {FaDollarSign} from "react-icons/fa";

const AssignLibraryList  = observer(({ viewMode, returnRoute }) => {
    const {book} = useContext(Context);
    const shownRef = useRef(new Set());
    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [selectedBonus, setSelectedBonus] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [bonus, setBonus] = useState(0);


    const calculateBonus = (item, book) => {
        let totalBonus = 0;
        const now = Date.now() / 60000; // текущие минуты

        // По типу ассигмента
        if (book?.asstypes) {
            const assignmentType = book.asstypes.find(type => type.id === item.assTypeId);
            if (assignmentType &&
                assignmentType.promotion_ass_price_bonus &&
                assignmentType.promotion_ass_price_bonus_start_date <= now &&
                assignmentType.promotion_ass_price_bonus_end_date >= now
            ) {
                totalBonus += assignmentType.promotion_ass_price_bonus;
            }
        }

        // По типу книги
        if (book?.types) {
            const bookType = book.types.find(type => type.id === item.booksTypeId);
            if (bookType &&
                bookType.book_type_promotion_price_bonus &&
                bookType.book_type_promotion_price_bonus_start_date <= now &&
                bookType.book_type_promotion_price_bonus_end_date >= now
            ) {
                totalBonus += bookType.book_type_promotion_price_bonus;
            }
        }

        // По типу цены
        if (book?.prices) {
            const priceType = book.prices.find(price => price.id === item.booksPriceId);
            if (priceType &&
                priceType.promotion_price_bonus &&
                priceType.promotion_price_bonus_start_date <= now &&
                priceType.promotion_price_bonus_end_date >= now
            ) {
                totalBonus += priceType.promotion_price_bonus;
            }
        }

        return totalBonus;
    };



    const incrementView = async (assignmentId) => {
        const assignmentIdNumber = Number(assignmentId);
        if (isNaN(assignmentIdNumber)) {
            return;
        }
        const assignment = book?.assignments.find(item => Number(item.id) === assignmentIdNumber);
        if (assignment) {
            const data = await markAssignmentLibraryView(assignmentId);
            if (data?.assignment?.views != null) {
                assignment.views = data.assignment.views;
            }
            if (data?.assignment?.last_library_view_at != null) {
                assignment.last_library_view_at = data.assignment.last_library_view_at;
            }
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const assignmentId = entry.target.dataset.assignmentId;
                        if (!shownRef.current.has(assignmentId)) {
                            shownRef.current.add(assignmentId);
                            incrementView(assignmentId);
                        }
                    }
                });
            },
            { threshold: 0.5 }
        );

        const timer = setTimeout(() => {
            const cards = document.querySelectorAll('.assignment-card');
            cards.forEach(card => observer.observe(card));
        }, 100);

        return () => {
            clearTimeout(timer);
            observer.disconnect();
        };
    }, [book?.assignments?.slice()]);

    const isAlwaysOnTopActive = (assignment) => {
        const untilMs = Number(assignment?.always_on_top_until || 0);
        return Number.isFinite(untilMs) && untilMs > Date.now();
    };

    const isBookAlwaysOnTopActive = (assignment) => {
        const untilMs = Number(assignment?.book?.always_on_top_until || assignment?.Book?.always_on_top_until || 0);
        return Number.isFinite(untilMs) && untilMs > Date.now();
    };

    const ALWAYS_ON_TOP_LIBRARY_LIMIT = 8;

    const getAlwaysOnTopBadge = (assignment, index) => {
        const isPinnedOnTopPosition =
            Number(book?.page || 1) === 1 &&
            index < ALWAYS_ON_TOP_LIBRARY_LIMIT &&
            (isBookAlwaysOnTopActive(assignment) || isAlwaysOnTopActive(assignment));

        if (!isPinnedOnTopPosition) return null;

        if (isBookAlwaysOnTopActive(assignment)) {
            const itemType = String(assignment?.book?.book_type || assignment?.Book?.book_type || "").toLowerCase();
            return {
                label: itemType === "product" ? "Product on top" : "Book on top",
                className: "bg-success",
            };
        }
        if (isAlwaysOnTopActive(assignment)) {
            return { label: "On top", className: "bg-success" };
        }
        return null;
    };

    const assignments = (() => {
        const rows = (book?.assignments || []).slice();
        if (!book?.sortassignments) return rows;

        const pinnedOnTop = [];
        const sortable = [];
        const isFirstPage = Number(book?.page || 1) === 1;

        rows.forEach((assignment, index) => {
            const row = { assignment, index };
            if (
                isFirstPage &&
                index < ALWAYS_ON_TOP_LIBRARY_LIMIT &&
                (isBookAlwaysOnTopActive(assignment) || isAlwaysOnTopActive(assignment))
            ) {
                pinnedOnTop.push(row);
                return;
            }
            sortable.push(row);
        });

        sortable.sort((a, b) => {
            const priceDiff =
                Number(b.assignment?.assignment_price_reader || 0) -
                Number(a.assignment?.assignment_price_reader || 0);
            if (priceDiff !== 0) return priceDiff;
            return a.index - b.index;
        });

        return [...pinnedOnTop, ...sortable].map((row) => row.assignment);
    })();

    if (viewMode === 'table') {
        return (
            <>
                <style>
                    {`
            .table-hover tbody tr:hover {
               
                transform: scale(0.995);
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                transition: all 0.1s ease-in-out;
                background-color: #00f9ff;
            }
        `}
                </style>
            <div className="card shadow-sm mt-1 p-3">
                <div style={{ overflowX: 'auto' }}>
                    <Table striped bordered hover size="sm" style={{ minWidth: '900px', lineHeight: '14px', textWrap: 'nowrap' }}>
                        <thead className="table-success">
                        <tr className="text-start small fst-italic">
                            <th className="text-muted">#</th>
                            <th className="text-muted">Top</th>
                            <th className="text-muted">Title</th>
                            <th className="text-muted">Author</th>
                            <th className="text-muted">Language</th>
                            <th className="text-muted">Format</th>
                            <th className="text-muted">Type</th>

                        <th className="text-muted">Earn+Bonus</th>
                        <th className="text-muted">Words</th>
                            <th className="text-muted">Finish</th>

                        <th className="text-muted">Due Date</th>
                        <th className="text-muted">Purchase</th>
                        </tr>
                        </thead>
                        <tbody>
                        {assignments.map((item, index) => {
                            const dueDate = new Date((Math.floor(Date.now() / 60000) + item.turnaround_time) * 60 * 1000);
                            const formattedDate = dueDate.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                            }).replace(/ /g, "-");
                            const daysToRead = Math.ceil(item.turnaround_time / 60 / 24);
                            const speedUpLevel = item?.speed_up_level || 0;
                            const topBadge = getAlwaysOnTopBadge(item, index);

                            return (
                                <tr className={`small assignment-card ${speedUpLevel !== 0 ? 'fw-bold' : ''}`}
                                    data-assignment-id={item.id}
                                    key={item.id}
                                    onClick={async () => {
                                        try {
                                            // сначала выполняем запрос
                                            await editAssignment({
                                                id: item?.id,  // используем текущий item из строки таблицы
                                                clicks: item?.clicks + 1,
                                            });

                                            // если запрос успешен — ставим бонус и открываем модалку
                                            setSelectedAssignment(item);
                                            setSelectedBonus(calculateBonus(item, book));
                                            setShowModal(true);

                                        } catch (error) {
                                            const errorMessage = error.response?.data?.message || "An error occurred while calculating user assignments.";
                                            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                        }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td className="text-muted">{item.id}</td>
                                    <td className="text-muted">
                                        {topBadge && (
                                            <span className={`badge ${topBadge.className} text-uppercase me-1`} style={{ fontSize: "0.62rem" }}>
                                                {topBadge.label}
                                            </span>
                                        )}
                                    </td>
                                    <td className="text-muted">
                                        {item?.book?.title?.length > 30 ? item?.book?.title.substring(0, 30) + "..." : item?.book?.title}
                                    </td>
                                    <td className="text-muted">{item.book?.author || '-'}</td>
                                    <td className="text-muted">{item.book?.language || '-'}</td>
                                    <td className="text-muted">
                                    {item.booksTypeId === 1 && "Kindle"}
                                    {item.booksTypeId === 2 && "Paperback"}
                                    {item.booksTypeId === 3 && "Hardcover"}
                                    {item.booksTypeId === 4 && "Audio"}
                                        {item.booksTypeId === 5 && "Boost"}
                                        {item.booksTypeId === 6 && "Report"}
                                        {item.booksTypeId === 7 && "Product"}
                                    </td>

                                    <td className="text-muted">
                                        {item.assTypeId === 1 && "Universal Assignment"}
                                        {item.assTypeId === 2 && "Kindle Unlimited"}
                                        {item.assTypeId === 3 && "Verified Purchase"}
                                        {item.assTypeId === 4 && "Verified Purchase Img"}
                                        {item.assTypeId === 5 && "Ver/Pur Search&Buy"}
                                        {item.assTypeId === 6 && "Ver/Pur Search&Buy Img"}
                                        {item.assTypeId === 7 && "Universal Audio"}
                                        {item.assTypeId === 8 && "Audible Promo Code"}
                                        {item.assTypeId === 9 && "Verified Kindle Unlimited"}
                                        {item.assTypeId === 10 && "Paperback Buyout"}
                                        {item.assTypeId === 11 && "PB Search&BuyOut"}
                                        {item.assTypeId === 12 && "PB Verified + Img"}
                                        {item.assTypeId === 13 && "PB Verified + Video"}
                                        {item.assTypeId === 14 && "Hardcover BuyOut"}
                                        {item.assTypeId === 15 && "HC Search&BuyOut"}
                                        {item.assTypeId === 16 && "HC Verified + Img"}
                                        {item.assTypeId === 17 && "HC Verified + Video"}
                                        {item.assTypeId === 18 && "PB Verified Purchase"}
                                        {item.assTypeId === 19 && "PB Verified Search&Buy"}
                                        {item.assTypeId === 20 && "HC Verified Purchase"}
                                        {item.assTypeId === 21 && "HC Verified Search&Buy"}
                                        {item.assTypeId === 22 && "Product BuyOut"}
                                        {item.assTypeId === 23 && "Product Search&BuyOut"}
                                        {item.assTypeId === 24 && "Product Verified"}
                                        {item.assTypeId === 25 && "Product Verified + Img"}
                                        {item.assTypeId === 26 && "Product Verified + Video"}
                                        {item.assTypeId === 27 && "Product Verified Search&Buy"}
                                        {item.assTypeId === 28 && "Make Helpful Internal"}
                                        {item.assTypeId === 29 && "Write Report Internal"}
                                        {item.assTypeId === 30 && "Make Helpful External"}
                                        {item.assTypeId === 31 && "Write Report External"}
                                        {item.assTypeId === 32 && "Set Stars Rating"}

                                    </td>
                                    <td className="text-muted">
                                        <span className="text-danger">
                                            {item.assignment_price_reader}
                                            {calculateBonus(item, book) > 0 && (
                                                <>+{calculateBonus(item, book)} </>
                                            )} Virt
                                        </span>
                                    </td>
                                    <td className="text-muted">{item.book?.total_words || '-'}</td>
                                    <td className="text-muted">
                                        <span>{daysToRead} Day{daysToRead > 1 && 's'}</span>
                                    </td>
                                    <td className="text-muted">{formattedDate}</td>
                                    <td className="text-muted">

                                            {item?.assTypeId === 1 && (
                                                <span className="text-danger">Free File Download</span>
                                            )}
                                            {item?.assTypeId === 2 && (
                                                <span className="text-danger">Requires Kindle Unlimited</span>
                                            )}
                                        {item?.assTypeId === 8 && (
                                            <strong className="text-danger">Free Audible Promo Code</strong>
                                        )}
                                            {item?.assTypeId === 9 && (
                                                <span className="text-danger">Requires Paid KU Subscription</span>
                                            )}
                                            {[10,11,12,13,14,15,16,17,18,19,20,21].includes(item?.assTypeId) && (
                                                <span className="text-danger">Buy Book & Get Full Refund: ${item?.book_cost_compensation}</span>
                                            )}
                                        {[22,23,24,25,26,27].includes(item?.assTypeId) && (
                                            <span className="text-danger">Buy Product & Get Refund: ${item?.book_cost_compensation}</span>
                                        )}
                                            {[3, 4, 5, 6, 32].includes(item?.assTypeId) && (
                                                item?.assignment_price_amz === "Free Promotion" ? (
                                                    <strong className="text-danger">HOT!!! $0.00 Free Promo</strong>
                                                ) : (
                                                    <span className="text-danger">
                                                        Requires Book Purchase: {item.assignment_price_amz}
                                                    </span>
                                                )
                                            )}
                                        {[28,29,30,31].includes(item?.assTypeId) && (
                                            <strong className="text-danger">Free Tap (Existing Review)</strong>
                                        )}

                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>
            </div>
            <TakeThisAssignment
                show={showModal}
                handleClose={() => setShowModal(false)}
                assignment={selectedAssignment}
                totalBonus={selectedBonus}
                returnRoute={returnRoute}
            />
        </>
        );
    }

    return (
        <>
        <Row className="d-flex justify-content-start p-1">
            {assignments.map((b, index) => (
                <Col key={b.id} md={viewMode === "cards4" ? 3 : 4} className="d-flex justify-content-center p-0">
                    {viewMode === "cards4" ? (
                        <AssignLibraryItem4x
                            bookitem={b}
                            alwaysOnTopBadge={getAlwaysOnTopBadge(b, index)}
                            onOpen={(item, bonus) => {
                                setSelectedAssignment(item);
                                setSelectedBonus(bonus);
                                setShowModal(true);
                            }}
                        />
                    ) : (
                        <AssignLibraryItem3x
                            bookitem={b}
                            alwaysOnTopBadge={getAlwaysOnTopBadge(b, index)}
                            onOpen={(item, bonus) => {
                                setSelectedAssignment(item);
                                setSelectedBonus(bonus);
                                setShowModal(true);
                            }}
                        />
                    )}
                </Col>
            ))}
        </Row>
    <TakeThisAssignment
        show={showModal}
        handleClose={() => setShowModal(false)}
        assignment={selectedAssignment}
        totalBonus={selectedBonus}
        returnRoute={returnRoute}
    />
    </>
    );
});

export default AssignLibraryList;
